import React, { useState, useEffect, lazy, Suspense } from "react";
import { unstable_batchedUpdates } from "react-dom";
import axios from "axios";
import { removeUnicode } from "../utils/utilityFunctions";
import { useParams } from "react-router-dom";

// Components
import CustomMeta from "../components/CustomMeta/CustomMeta";
import SingleBlog from "../components/Blog/SingleBlog";
const PageNotFound = lazy(() =>
  import(/* webpackChunkName: "PageNotFound" */ "./pageNotFound")
);

// Load blog CSS at the page level so it's available during SSR hydration
import "../components/Blog/singleBlog.css";
import "../components/Blog/wordpress-style.min.css";

import { makeStyles } from 'tss-react/mui';
import { CircularProgress } from "@mui/material";

// Redux stuff
import { connect } from "react-redux";

let useStyles = makeStyles()((theme) => ({
  fullPageHeight: {
    minHeight: "100vh",
    width: "100%",
  },
  progressDiv: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
  },
}));

function singleBlog(props) {
  const { classes } = useStyles();
  const { slug } = useParams();

  function getInitialBlogData() {
    if (props.staticContext) return props.staticContext;
    if (typeof window !== "undefined" && window.__ROUTE_DATA__) {
      const data = window.__ROUTE_DATA__;
      delete window.__ROUTE_DATA__;
      return data;
    }
    return null;
  }

  const [initialData] = useState(getInitialBlogData);
  const [blogPostData, setBlogPostData] = useState(initialData);
  const [isLoading, setIsLoading] = useState(!initialData);
  const [relatedPosts, setRelatedPosts] = useState([]);
  const [isNotFound, setIsNotFound] = useState(false);

  useEffect(() => {
    if (blogPostData) {
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    axios
      .get(`/api/blogs/getBlogPost/${slug}`)
      .then((res) => {
        unstable_batchedUpdates(() => {
          setBlogPostData(res.data);
          setIsLoading(false);
          setIsNotFound(false);
        });
      })
      .catch((err) => {
        console.error("Unable to get single blog post data: ", err);
        unstable_batchedUpdates(() => {
          setIsLoading(false);
          setIsNotFound(true);
        });
      });
  }, [slug]);

  useEffect(() => {
    if (slug) {
      axios
        .get(`/api/blogs/getRelatedBlogPosts/${slug}`)
        .then((res) => setRelatedPosts(res.data))
        .catch((err) => {
          console.error("Unable to get related blog posts: ", err);
          setRelatedPosts([]);
        });
    }
  }, [slug]);

  return (
    <div className={classes.fullPageHeight}>
      {blogPostData ? (
        <CustomMeta
          title={removeUnicode(blogPostData.title)}
          description={removeUnicode(blogPostData.description)}
          ogImage={blogPostData.ogImage}
          url={blogPostData.url}
        />
      ) : null}
      {isLoading ? (
        <div className={classes.progressDiv}>
          <CircularProgress size={25} />
        </div>
      ) : isNotFound ? (
        <Suspense fallback={<div />}>
          <PageNotFound />
        </Suspense>
      ) : blogPostData ? (
        <SingleBlog
          blogPostData={blogPostData}
          relatedPosts={relatedPosts}
        />
      ) : null}
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.user,
  UI: state.UI,
});

export default connect(mapStateToProps)(singleBlog);
